import { LightbulbIcon } from '@/components/ui/icons';
import { Tag } from '@/components/ui/tag';
import { MOTION } from '@/utils';
import { useGSAP } from '@gsap/react';
import { gsap } from 'gsap';
import { useRef } from 'react';

export default function HowItWorks() {
  const refs = {
    section: useRef<HTMLElement>(null),
    steps: useRef<HTMLDivElement>(null),
    why: useRef<HTMLDivElement>(null),
  };

  useGSAP(
    () => {
      if (!refs.section.current) return;

      gsap
        .timeline({
          defaults: { duration: MOTION.durationMd, ease: MOTION.ease },
          scrollTrigger: {
            trigger: refs.section.current,
            start: 'top 65%',
            toggleActions: 'play none none reverse',
          },
        })
        .from([refs.steps.current, refs.why.current], {
          autoAlpha: 0,
          y: MOTION.y,
          stagger: 0.15,
        });
    },
    { scope: refs.section },
  );

  return (
    <section ref={refs.section} className="max-width-blue-section" id="tarif-fonctionnement">
      <div className="grid grid-cols-1 gap-12 md:grid-cols-2">
        {/* Étapes */}
        <div ref={refs.steps} className="flex flex-col gap-8">
          <Tag>Fonctionnement</Tag>

          <div className="flex gap-5">
            <span className="text-orange/25 font-roboto-bold mt-0.5 shrink-0 text-4xl leading-none tabular-nums">
              01
            </span>
            <div className="flex flex-col gap-1.5">
              <span className="text-dark-blue font-roboto-medium">Le cabinet s&apos;équipe</span>
              <p className="text-dark-blue/60 text-sm leading-relaxed">
                Tous les membres du cabinet utilisent zLawyer Cabinet au tarif de{' '}
                <strong className="text-dark-blue/80 font-roboto-medium">
                  49&nbsp;€/utilisateur/mois
                </strong>
                .
              </p>
            </div>
          </div>

          <div className="flex gap-5">
            <span className="text-orange/25 font-roboto-bold mt-0.5 shrink-0 text-4xl leading-none tabular-nums">
              02
            </span>
            <div className="flex flex-col gap-1.5">
              <span className="text-dark-blue font-roboto-medium">
                Le collaborateur ouvre son compte personnel
              </span>
              <p className="text-dark-blue/60 text-sm leading-relaxed">
                S&apos;il en a besoin, il souscrit à zLawyer Collaborateur à{' '}
                <strong className="text-dark-blue/80 font-roboto-medium">17&nbsp;€/mois</strong>{' '}
                pour gérer son activité indépendante.
              </p>
            </div>
          </div>
        </div>

        {/* Pourquoi cette offre */}
        <div
          ref={refs.why}
          className="border-dark-blue/10 flex flex-col gap-4 rounded-(--radius-current) border bg-white/10 p-8"
        >
          <div className="flex items-center gap-2">
            <div className="text-orange">
              <LightbulbIcon />
            </div>
            <span className="text-dark-blue font-roboto-medium">Pourquoi cette offre&nbsp;?</span>
          </div>
          <p className="text-dark-blue/60 text-sm leading-relaxed">
            Les collaborateurs peuvent être amenés à refacturer le cabinet dans lequel ils
            travaillent et exercer une activité indépendante en parallèle.
          </p>
          <p className="text-dark-blue/60 text-sm leading-relaxed">
            zLawyer Collaborateur leur permet de disposer de leur propre plateforme pour gérer
            cette activité et leur facturation électronique en toute simplicité.
          </p>
        </div>
      </div>
    </section>
  );
}
